<template>
  <div class="apps-container">
    <div class="apps-inner">
      <div class="category">
        <div>
          <span class="active" @click="selectCategory">全部</span>
          <span v-for="item in categoryList" :key="item.id" @click="selectCategory($event, item)">
            {{ item.name }}</span>
        </div>
      </div>

      <div class="app" v-for="{ id, name, children } in appList" :data-title="name" :key="id">
        <div v-for="{ id, name, customIcon, sourceType, url } in children" :key="id"
          @click="clickApp(sourceType, id, url)">
          <el-image :src="baseUrl + customIcon">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture"></i>
            </div>
          </el-image>
          <b>{{ name }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api.js'
export default {
  name: 'Apps',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      categoryList: [],
      appList: [],
      userInfo: {}
    }
  },
  async created() {
    if (this.userRole != 4) {
      const { data: { userOperationList } } = await api.getAppList({ platformType: 1 })
      this.appList = this.categoryList = userOperationList.filter(item => item.children.length)
    }
  },
  methods: {
    selectCategory(e, item) {
      const categoryList = document.querySelectorAll('.category div span')
      categoryList.forEach(item => {
        item.classList.remove('active')
      })
      e.target.classList.add('active')
      this.appList = item ? [item] : this.categoryList
    },
    async clickApp(sourceType, id, url) {
      await api.logUserClick({ idOperate: id, type: 1 })
      console.log(sourceType, sourceType == 1 ? jumpURL + url : url)
      window.open(sourceType === 1 ? jumpURL + url : url)
    }
  }
}
</script>

<style lang="scss" scoped>
.apps-container {
  min-height: calc(100vh - 340px);

  .apps-inner {
    width: var(--inner-width);
    margin: auto;
    padding: 54px 0 109px;

    .category {
      margin-bottom: 74px;
      display: flex;
      gap: 20px;

      &::before {
        content: '应用分类';
        color: #999;
        transform: translateY(8px);
        font-size: 17px;
        font-weight: bold;
      }

      p {
        color: #333;
        transform: translateY(5px);
        font-size: 18px;
      }

      div {
        flex: 1;
        display: flex;
        gap: 20px;
        flex-wrap: wrap;

        span {
          background: #eee;
          padding: 8px 20px;
          color: #333;
          border-radius: 4px;
          cursor: pointer;
          transition: 300ms ease-in-out;

          &:hover {
            color: $mainColor;
          }

          &.active {
            background: $mainColor;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }

    .app {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 28px;
      position: relative;
      margin-top: 133px;

      &::before {
        content: '';
        width: 4px;
        height: 22px;
        left: 2px;
        background: var(--mainColor);
        position: absolute;
        top: -48px;
        color: #333;
      }

      &::after {
        content: attr(data-title);
        position: absolute;
        top: -52px;
        left: 15px;
        color: #333;
        font-size: 24px;
        font-weight: bold;
        font-family: serif;
      }

      >div {
        display: flex;
        align-items: center;
        gap: 20px;
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        border: 1.5px solid #f2f2f2;
        cursor: pointer;
        transition: 300ms;

        &:hover {
          border-color: $mainColor;
          scale: .97;
        }

        .el-image {
          width: 44px;
          aspect-ratio: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
          border-radius: 8px;
          color: $infoColor;
        }

        b {
          font-size: 18px;
          color: #333;
        }
      }
    }
  }
}
</style>